import React, { useState, createContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home/Home";
import EnvironmentVariation from "./pages/environment-variaton/EnvironmentVariation";
import Tabs from "./components/tabs/Tabs";
import PatternSelection from "./pages/pattern-selection/PatternSelection";
import SharePage from "./pages/share-page/SharePage";
import styles from "./App.styles.scss";
import axios from "axios";
import TagManager from 'react-gtm-module';

export const UserContext = createContext();

const SimulatorApp = () => {
    const [environment, setEnvironment] = useState(null);
    const [envVariation, setEnvVariation] = useState(null);
    const [primaryPattern, setPrimaryPattern] = useState(null);
    const [secondaryPattern, setSecondaryPattern] = useState(null);
    const [thirdPattern, setThirdPattern] = useState(null);
    const [step, setStep] = useState(1);
    const [isTotem, setIsTotem] = useState(
        window.location.href.includes("totem")
    );

    useEffect(() => {
        TagManager.initialize({ gtmId: process.env.MIX_GOOGLE_TAG_MANAGER });
    }, []);

    if (isTotem && localStorage.getItem("simulator-cached") !== "1") {
        useEffect(() => {
            axios
                .get(`${MIX_URL}/simulator-api/all-patterns`)
                .then(async (response) => {
                    const opts = [];
                    const images = await response.data.patterns.map(
                        (pattern) =>
                            new Promise((rs, rj) => {
                                const img = new Image();
                                img.src = `${MIX_AWS_URL}/${pattern.thumb_image}`;
                                img.onload = () => rs(img);
                                img.onerror = () => rj();

                                pattern.environment_option_patterns.forEach(
                                    (opt) => {
                                        opts.push(
                                            `${MIX_AWS_URL}/${opt.image}`
                                        );
                                    }
                                );
                            })
                    );

                    const opt = await opts.map(
                        (image) =>
                            new Promise((rs, rj) => {
                                const img = new Image();
                                img.src = image;
                                img.onload = () => rs(img);
                                img.onerror = () => rj();
                            })
                    );

                    const finalImages = [...images, opt];

                    await Promise.all(finalImages).catch((err) =>
                        console.log(err)
                    );

                    localStorage.setItem("simulator-cached", "1");
                });
        }, []);
    }

    let baseName = window.location.href.includes("localhost")
        ? `${window.location.href.includes("totem") ? "/totem" : ""}/simulador/`
        : `/${process.env.MIX_APP_DIR}${
              window.location.href.includes("totem") ? "/totem" : ""
          }/simulador/`;

    return (
        <BrowserRouter
            basename={baseName.replace(window.location.host + "/", "")}
        >
            <UserContext.Provider
                value={{
                    environment,
                    setEnvironment,
                    envVariation,
                    setEnvVariation,
                    primaryPattern,
                    setPrimaryPattern,
                    secondaryPattern,
                    setSecondaryPattern,
                    thirdPattern,
                    setThirdPattern,
                    step,
                    setStep,
                    isTotem,
                    setIsTotem,
                }}
            >
                <div className={`SimulatorApp ${isTotem ? "totem" : ""}`}>
                    <Tabs />
                    <Routes>
                        <Route
                            exact
                            path="/"
                            element={<Navigate to="/escolha-um-ambiente" />}
                        />
                        <Route
                            exact
                            path="/escolha-um-ambiente"
                            element={<Home />}
                        />
                        <Route
                            exact
                            path="/:environment/opcao-de-ambiente"
                            element={<EnvironmentVariation />}
                        />
                        <Route
                            path="/:environment/:enviromentVariation/selecione-um-padrao"
                            element={<PatternSelection />}
                        />
                        <Route
                            path="/:environment/:enviromentVariation/:pattern"
                            element={<SharePage />}
                        ></Route>
                    </Routes>
                </div>
            </UserContext.Provider>
        </BrowserRouter>
    );
};

if (document.getElementById("simulatorApp")) {
    ReactDOM.render(<SimulatorApp />, document.getElementById("simulatorApp"));
}
